import * as EP from "./endpoints";
import HTTP from "@/packages/http";

export const ImportExportService = {
  addSupportingDoc(formData) {
    return HTTP.post(EP.ADD_ESANCHIT_SUPPORTING_DOC, { ...formData }).then(({ data }) => data);
  },
  deleteSupportingDoc(id) {
    return HTTP.delete(EP.DELETE_ESANCHIT_SUPPORTING_DOC + id).then(({ data }) => data);
  },
  updateSupportingDoc(formData) {
    return HTTP.patch(EP.UPDATE_ESANCHIT_SUPPORTING_DOC + formData.id, { ...formData }).then(({ data }) => data);
  },
  getSupportingDoc(id) {
    return HTTP.get(EP.GET_ESANCHIT_SUPPORTING_DOC + id).then(({ data }) => data);
  }
};
